module.exports = __webpack_public_path__ + "img/html-evolution-4.92575f47.webp";